import { NgModule } from '@angular/core';
import { DynamicItemDirective } from './directives';

@NgModule({
  declarations: [DynamicItemDirective],
  exports: [DynamicItemDirective],
  schemas: [],
})
export class DynamicRenderModule {}
